import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
} from '@/components/common/skeleton';

const ORG_COUNT = 4;
const FLAGS_PER_ORG = 2;

export const FeatureFlagsSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: ORG_COUNT }).map((_org, orgIdx) => (
      <View key={orgIdx} style={styles.accordion}>
        <View style={styles.headerRow}>
          <SkeletonBone width={8} height={8} borderRadius={4} />
          <SkeletonBone width={200} height={16} />
          <View style={styles.headerSpacer} />
          <SkeletonBone width={16} height={16} borderRadius={4} />
        </View>
        <View style={styles.flagsInset}>
          {Array.from({ length: FLAGS_PER_ORG }).map((_flag, flagIdx) => (
            <SkeletonBone key={flagIdx} width="80%" height={14} />
          ))}
        </View>
      </View>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 12,
    gap: 16,
  },
  accordion: {
    gap: 12,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  headerSpacer: {
    flex: 1,
  },
  flagsInset: {
    paddingLeft: 24,
    gap: 8,
  },
});
